/**
 * Утилиты для форматирования дат, размеров файлов и строковых данных почты
 */

/**
 * Компактное форматирование даты для списка писем
 * (сегодня -> время, этот год -> день месяц, прошлый год -> дата)
 */
export function formatMailDate(timestampMs?: number | null): string {
  if (!timestampMs) return '';
  const date = new Date(timestampMs);
  if (isNaN(date.getTime())) return '';

  const now = new Date();
  const isToday =
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();

  if (isToday) {
    return date.toLocaleTimeString('ru-RU', {
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  const isYesterday =
    date.getDate() === yesterday.getDate() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getFullYear() === yesterday.getFullYear();

  if (isYesterday) {
    return 'Вчера';
  }

  const isCurrentYear = date.getFullYear() === now.getFullYear();
  if (isCurrentYear) {
    return date.toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'short'
    });
  }

  return date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
}

/**
 * Полное форматирование даты и времени для заголовка открытого письма
 */
export function formatMailFullDate(timestampMs?: number | null): string {
  if (!timestampMs) return '';
  const date = new Date(timestampMs);
  if (isNaN(date.getTime())) return '';

  return date.toLocaleString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

/**
 * Форматирование размера файлов в байтах в человекочитаемый вид (КБ, МБ)
 */
export function formatFileSize(bytes?: number): string {
  if (!bytes || bytes <= 0) return '0 Б';
  const k = 1024;
  const sizes = ['Б', 'КБ', 'МБ', 'ГБ'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
}

/**
 * Инициалы отправителя для красивого аватара
 */
export function getMailInitials(name?: string, email?: string): string {
  const target = (name || email || '').trim();
  if (!target) return '?';

  // Если это ФИО через пробел
  const parts = target.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }

  // Если это email: берем первые 1-2 буквы до @
  const clean = target.split('@')[0].replace(/[^a-zA-Zа-яА-Я0-9]/g, '');
  return clean.slice(0, 2).toUpperCase() || target.slice(0, 1).toUpperCase();
}

/**
 * Генерация стабильного пастельного цвета для аватара отправителя
 */
export function getAvatarColor(str: string): string {
  const colors = [
    '#2563eb',
    '#059669',
    '#d97706',
    '#7c3aed',
    '#db2777',
    '#0891b2',
    '#4f46e5',
    '#ca8a04',
    '#ea580c'
  ];
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % colors.length;
  return colors[index];
}
